export enum CollectionHandle {
  // Make sure to update the BundleCollectionHandle Omit<> below if you add a new non-bundle collection
  All = 'all',
  BestSellers = 'bestsellers',
  Bodysuits = 'bodysuits',
  Bottoms = 'bottoms',
  Bras = 'bras',
  Discounted = 'discounted',
  GoogleShoppingFeed = 'google-shopping-feed',
  Sculptwear = 'sculptwear',
  Liftwear = 'liftwear',
  Tops = 'tops',
  TryNow = 'trynow',
  Underwear = 'underwear',
}

export enum BundleCollectionHandle {
  // Bundles: suffix -bundle //
  SilhouetteBundle = 'silhouette-bundle', // Silhouette Brief + Silhouette Bra
}

export const isCollectionHandle = (maybeCollectionHandle: unknown): maybeCollectionHandle is CollectionHandle =>
  Object.values(CollectionHandle).includes(maybeCollectionHandle as CollectionHandle);

export const isBundleCollectionHandle = (maybeBundleCollectionHandle: unknown): maybeBundleCollectionHandle is BundleCollectionHandle =>
  Object.values(BundleCollectionHandle).includes(maybeBundleCollectionHandle as BundleCollectionHandle);
